<template>
	<div class="create-page">
		<div class="create-content">
			<el-form ref="form" :model="form" :rules="rules" label-position="top">
				<!-- 索赔类型 -->
				<div class="create-section" v-if="form.repairType != ''">
					<h3>索赔类型</h3>
					<div class="grid-box">
						<div>
							<el-form-item label="索赔类型" prop="matertialType">
								<el-select v-model="form.matertialType" placeholder="请选择" class="full-width">
									<el-option
										v-for="option in matertialTypeOptions"
										:key="option.value"
										:label="option.label"
										:value="option.value"></el-option>
								</el-select>
							</el-form-item>
						</div>
					</div>
				</div>
				<!-- 申请方信息 -->
				<div class="create-section" v-if="form.repairType != ''">
					<h3>申请方信息</h3>
					<div class="grid-box">
						<div>
							<el-form-item label="机构类型" prop="applyOrgType">
								<el-select v-model="form.applyOrgType" placeholder="请选择" class="full-width" @change="changeApplyOrgType">
									<el-option
										v-for="option in applyOrgTypeOptions"
										:key="option.value"
										:label="option.label"
										:value="option.value"></el-option>
								</el-select>
							</el-form-item>
						</div>
						<div v-if="form.applyOrgType != ''">
							<el-form-item label="1" prop="applyOrgId" class="hidden-label">
								<el-select
									v-model="form.applyOrgId"
									placeholder="请选择"
									class="full-width"
									filterable
									remote
									@change="getApplyUser"
									:remote-method="getApplyList">
									<el-option v-for="option in applyOptions" :key="option.id" :label="option.name" :value="option.id"></el-option>
								</el-select>
							</el-form-item>
						</div>
					</div>
					<div class="claim-user-box" v-if="applyOrgFlag">
						<el-form-item label="索赔管理员" prop="applyOrgId">
							<div class="claim-user" v-if="applyUserList.length > 0" v-for="(item, i) in applyUserList" :key="item.id">
								{{ item.name && item.tel ? `${item.name}/${item.tel}` : item.name || item.tel }}
							</div>
							<div v-if="applyUserList.length == 0">该机构暂无索赔管理员，无法进行索赔申请</div>
						</el-form-item>
					</div>
				</div>
				<!-- 日志 -->
				<div class="create-section log-section" v-if="logList.length > 0">
					<h3>日志</h3>
					<el-table :data="logList" :header-cell-style="{ color: '#444' }">
						<el-table-column prop="createTime" label="时间" width="160"></el-table-column>
						<el-table-column prop="createUsrCompany" label="执行方"></el-table-column>
						<el-table-column prop="createName" label="执行人" width="120"></el-table-column>
						<el-table-column prop="operNotes" label="事件"></el-table-column>
						<el-table-column prop="remark" label="批注"></el-table-column>
					</el-table>
				</div>
				<!-- 基本信息 -->
				<div class="create-section" v-if="form.applyOrgId != ''">
					<h3>基本信息</h3>
					<div class="grid-box">
						<div>
							<el-form-item label="机型及开发名" prop="repairDevices">
								<el-cascader v-model="form.repairDevices" :options="repairDeviceOptions" :props="{ value: 'id', label: 'name' }"></el-cascader>
							</el-form-item>
						</div>
						<div>
							<el-form-item label="机号" prop="repairDeviceNumber">
								<el-input v-model="form.repairDeviceNumber" placeholder="请输入机号"></el-input>
							</el-form-item>
						</div>
					</div>
					<div class="grid-box">
						<div>
							<el-form-item label="开始使用日" prop="partsClaimMaterial.startUseDate">
								<el-date-picker
									v-model="form.partsClaimMaterial.startUseDate"
									format="yyyy-MM-dd"
									value-format="yyyy-MM-dd"
									type="date"
									:picker-options="pickerOptions"
									placeholder="请选择开始使用日"></el-date-picker>
							</el-form-item>
						</div>
						<div>
							<el-form-item label="问题发生日" prop="partsClaimMaterial.issueDate">
								<el-date-picker
									v-model="form.partsClaimMaterial.issueDate"
									format="yyyy-MM-dd"
									value-format="yyyy-MM-dd"
									type="date"
									:picker-options="pickerOptions"
									placeholder="请选择问题发生日"></el-date-picker>
							</el-form-item>
						</div>
						<div>
							<el-form-item label="使用张数" prop="partsClaimMaterial.pagesUsed">
								<el-input v-model="form.partsClaimMaterial.pagesUsed" placeholder="请输入内容"></el-input>
							</el-form-item>
						</div>
					</div>
					<div class="mr20">
						<el-form-item label="故障现象" prop="partsClaimMaterial.failureSymptom">
							<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.partsClaimMaterial.failureSymptom"></el-input>
						</el-form-item>
					</div>
					<div class="mr20">
						<el-form-item label="故障处理措施" prop="partsClaimMaterial.failureAction">
							<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.partsClaimMaterial.failureAction"></el-input>
						</el-form-item>
					</div>
					<div class="mr20">
						<el-form-item label="补充说明栏" prop="partsClaimMaterial.additionalNotes">
							<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.partsClaimMaterial.additionalNotes"></el-input>
						</el-form-item>
					</div>
				</div>
				<!-- 上传附件 -->
				<div class="create-section" v-if="form.applyOrgId != ''">
					<h3>上传附件</h3>
					<!-- 理光出库一览表 -->
					<div class="upload-box">
						<h4>理光出库一览表</h4>
						<el-upload
							:action="action"
							:headers="headers"
							:multiple="true"
							:show-file-list="false"
							:before-upload="handleBeforeUpload"
							:on-error="handleError"
							:on-success="(res, file, list) => handleSuccess('ricohOutbound', res, file, list)">
							<el-button icon="el-icon-paperclip">上传文件</el-button>
						</el-upload>
						<FileList
							:file-list="ricohOutboundFileIdList"
							list-name="ricohOutboundFileIdList"
							closable
							@onRemove="handleAttachFileRemove"
							class="mt4"></FileList>
					</div>
					<!-- 理光购货发票 -->
					<div class="upload-box">
						<h4>理光购货发票</h4>
						<el-upload
							:action="action"
							:headers="headers"
							:multiple="true"
							:show-file-list="false"
							:before-upload="handleBeforeUpload"
							:on-error="handleError"
							:on-success="(res, file, list) => handleSuccess('ricohPurchase', res, file, list)">
							<el-button icon="el-icon-paperclip">上传文件</el-button>
						</el-upload>
						<FileList
							:file-list="ricohPurchaseFileIdList"
							list-name="ricohPurchaseFileIdList"
							closable
							@onRemove="handleAttachFileRemove"
							class="mt4"></FileList>
					</div>
					<!-- 故障件照片和样张 -->
					<div class="upload-box">
						<h4>故障件照片和样张</h4>
						<el-upload
							:action="action"
							:headers="headers"
							:multiple="true"
							:show-file-list="false"
							:before-upload="handleBeforeUpload"
							:on-error="handleError"
							:on-success="(res, file, list) => handleSuccess('faultyParts', res, file, list)">
							<el-button icon="el-icon-paperclip">上传文件</el-button>
						</el-upload>
						<FileList
							:file-list="faultyPartsFileIdList"
							list-name="faultyPartsFileIdList"
							closable
							@onRemove="handleAttachFileRemove"
							class="mt4"></FileList>
					</div>
				</div>
				<!-- 客户信息 -->
				<div class="create-section" v-if="form.applyOrgId != ''">
					<h3>客户信息</h3>
					<div class="grid-box">
						<div>
							<el-form-item label="用户名" prop="partsClaimCustomer.userName">
								<el-input v-model="form.partsClaimCustomer.userName" placeholder="请输入用户名"></el-input>
							</el-form-item>
						</div>
						<div>
							<el-form-item label="联系人姓名" prop="partsClaimCustomer.contactName">
								<el-input v-model="form.partsClaimCustomer.contactName" placeholder="请输入联系人姓名"></el-input>
							</el-form-item>
						</div>
						<div>
							<el-form-item label="用户电话" prop="partsClaimCustomer.userPhone">
								<el-input v-model="form.partsClaimCustomer.userPhone" placeholder="请输入用户电话"></el-input>
							</el-form-item>
						</div>
					</div>
					<div class="grid-box grid-box1">
						<div>
							<el-form-item label="省市区" prop="partsClaimCustomer.allAddress">
								<el-cascader
									v-model="form.partsClaimCustomer.allAddress"
									:options="addressOptions"
									:props="{ value: 'code', label: 'name' }"></el-cascader>
							</el-form-item>
						</div>
						<div>
							<el-form-item label="详细地址" prop="partsClaimCustomer.addressDetail">
								<el-input v-model="form.partsClaimCustomer.addressDetail" placeholder="例:xxx路xxx街道xxx号"></el-input>
							</el-form-item>
						</div>
					</div>
				</div>
				<!-- 机器零件信息 -->
				<div class="create-section" v-if="form.repairType != ''">
					<h3>{{ partTitleObj[form.repairType] }}信息</h3>
					<!-- 动态生成的零件信息部分 -->
					<div class="flex part-info-box" v-for="(part, index) in form.partsDetailList" :key="index">
						<div class="flex-1">
							<div class="part-info-item">
								<el-form-item
									:label="`${partTitleObj[form.repairType]}名称`"
									:prop="`partsDetailList.${index}.partsName`"
									:rules="rules.partsDetailList.partsName">
									<el-input v-model="part.partsName" :placeholder="`请输入${partTitleObj[form.repairType]}名称`"></el-input>
								</el-form-item>
								<i class="el-icon-tickets" @click="$copyText(part.partsName)"></i>
							</div>
							<div class="part-info-item">
								<el-form-item
									:label="`${partTitleObj[form.repairType]}编号`"
									:prop="`partsDetailList.${index}.partsNumber`"
									:rules="rules.partsDetailList.partsNumber">
									<el-input v-model="part.partsNumber" :placeholder="`请输入${partTitleObj[form.repairType]}编号`"></el-input>
								</el-form-item>
								<i class="el-icon-tickets" @click="$copyText(part.partsNumber)"></i>
							</div>
							<div class="part-info-item">
								<el-form-item :label="'申请数量'" :prop="`partsDetailList.${index}.partsAmount`" :rules="rules.partsDetailList.partsAmount">
									<el-input v-model="part.partsAmount" placeholder="请输入申请数量"></el-input>
								</el-form-item>
								<i class="el-icon-tickets" @click="$copyText(part.partsAmount)"></i>
							</div>
							<div class="delete-btn-box">
								<i class="el-icon-delete-solid" @click="removePartInfo(index)"></i>
							</div>
						</div>
						<div class="flex-1 part-info-box-right"></div>
					</div>
					<el-button type="primary" class="ml20 mt20" @click="addPartInfo">新增{{ partTitleObj[form.repairType] }}</el-button>
				</div>
			</el-form>
		</div>
		<!-- 底部按钮区域 -->
		<div class="create-footer" v-if="form.applyOrgId != ''">
			<div>
				<el-button type="info" @click="handleBack">返回</el-button>
			</div>
			<el-button v-if="form.id" type="danger" @click="handleRevocation">撤销</el-button>
			<el-button type="warning" @click="handleSubmit('0')" v-if="![-2, -3].includes(auditStatus)">暂存</el-button>
			<el-button type="primary" @click="handleSubmit('1')">{{ [-2, -3].includes(auditStatus) ? "重新提交" : "提交" }}</el-button>
		</div>
		<!-- 右侧边固定按钮区域 -->
		<div class="fixed-btn-box" v-if="form.applyOrgId != '' && ![-2, -3].includes(auditStatus)">
			<el-button type="info" @click="handleBack">返回</el-button>
			<el-button v-if="form.id" type="danger" @click="handleRevocation">撤销</el-button>
			<el-button type="warning" @click="handleSubmit('0')">暂存</el-button>
			<el-button type="primary" @click="handleSubmit('1')">提交</el-button>
		</div>
	</div>
</template>

<script>
import { claimMaterialInfo } from "@/api/claim";
import { debounce } from "@/utils/debounce";
const defaultSettings = require("@/settings.js");
const hostName = defaultSettings.hostName;
import FileList from "../components/FileList.vue";
export default {
	components: {
		FileList,
	},
	data() {
		return {
			// 索赔类型
			matertialTypeOptions: [
				{
					value: "1",
					label: "主机",
				},
				{
					value: "2",
					label: "耗材",
				},
				{
					value: "3",
					label: "选购件",
				},
			],
			// 签约类型
			applyOrgTypeOptions: [
				{
					value: "2",
					label: "特约维修店",
				},
				{
					value: "3",
					label: "代理商",
				},
				{
					value: "4",
					label: "分部",
				},
			],
			// 申请方信息
			applyOptions: [],
			// 申请方人员信息
			applyUserList: [],
			// 机型及开发名
			repairDeviceOptions: [],
			// 省市县三级
			addressOptions: [],
			form: {
				matertialType: "", //商品（耗材故障） 具体类型 1主机  2耗材 3选购件
				repairType: "3", // 索赔的类型 1、保修期内机器零件故障 2、理光单独订购零件 3、商品（耗材故障）
				applyOrgType: "", // 申请方信息-机构类型 1、网络店 2、特约维修店 3、代理商 4、分部
				applyOrgId: "", // 申请方信息 对应的机构id
				repairModelId: "", // 机型及开发名 一级
				repairDeviceId: "", // 机型及开发名 二级
				repairDeviceNumber: "", // 机号
				isSubmit: 0, // 是否提交 0否(表示暂存)  1是(提交索赔)
				repairDevices: [],
				//基本信息
				partsClaimMaterial: {
					startUseDate: "", // 开始使用日
					issueDate: "", // 问题发生日
					pagesUsed: "", // 使用张数
					failureSymptom: "", // 故障现象
					failureAction: "", // 故障措施
					additionalNotes: "", // 补充说明栏
					ricohOutboundFileIdList: [], //理光出库一览表 单上传文件的id
					ricohPurchaseFileIdList: [], //理光购货发票 上传文件的id
					faultyPartsFileIdList: [], //故障件照片和样张 上传文件的id
				},
				// 客户信息
				partsClaimCustomer: {
					// 省市县三级，提交时删除
					allAddress: [],
					userName: "", // 用户名
					contactName: "", // 联系人姓名
					userPhone: "", // 用户电话
					province: "", // 省
					city: "", // 市
					district: "", // 区县
					addressDetail: "", // 详细地址
				},
				// 机器零件信息
				partsDetailList: [],
			},
			rules: {
				matertialType: [{ required: true, message: "请选择索赔类型", trigger: "blur" }],
				repairDevices: [{ required: true, message: "机型及开发名", trigger: "blur" }],
				repairDeviceNumber: [{ required: true, message: "请输入机号", trigger: "blur" }],
				partsClaimMaterial: {
					startUseDate: [
						{
							required: true,
							message: "请选择开始使用日",
							trigger: "blur",
						},
					],
					issueDate: [
						{
							required: true,
							message: "请选择问题发生日",
							trigger: "blur",
						},
					],
					pagesUsed: [
						{
							required: true,
							message: "请输入使用张数",
							trigger: "blur",
						},
					],
					failureSymptom: [{ required: true, message: "请输入内容", trigger: "blur" }],
					failureAction: [{ required: true, message: "请输入内容", trigger: "blur" }],
				},
				partsClaimCustomer: {
					allAddress: [{ required: true, message: "请选择", trigger: "blur" }],
					userName: [{ required: true, message: "请输入用户名", trigger: "blur" }],
					contactName: [
						{
							required: true,
							message: "请输入联系人姓名",
							trigger: "blur",
						},
					],
					userPhone: [
						{
							required: true,
							message: "请输入用户电话",
							trigger: "blur",
						},
					],
				},
				partsDetailList: {
					partsName: [
						{
							required: true,
							message: "请输入机器零件名称",
							trigger: "blur",
						},
					],
					partsNumber: [
						{
							required: true,
							message: "请输入机器零件编号",
							trigger: "blur",
						},
					],
					partsAmount: [
						{
							required: true,
							message: "请输入申请数量",
							trigger: "blur",
						},
						{
							pattern: /^[1-9]\d*$/,
							message: "数量必须为正整数",
							trigger: "blur",
						},
					],
				},
			},
			// 理光出库一览表附件列表
			ricohOutboundFileIdList: [],
			// 理光购货发票附件列表
			ricohPurchaseFileIdList: [],
			// 故障件照片和样张附件列表
			faultyPartsFileIdList: [],
			// 机器零件列表
			partsDetailList: [],
			// 索赔管理员是否显示
			applyOrgFlag: false,
			// 资料审核管理员是否显示
			auditOrgFlag: false,
			// 订购信息
			partTitleObj: {
				1: "机器零件",
				2: "订购零件",
				3: "商品(耗材)",
			},
			auditStatus: "",
			pickerOptions: {
				disabledDate(time) {
					// 禁用今天之后的日期（只能选今天及之前）
					return time.getTime() > Date.now();
				},
			},
			logList: [],
		};
	},
	computed: {
		action() {
			return hostName + "bsi/sysAttachFile/addFileOss";
		},
		headers() {
			const token = sessionStorage.getItem("token") || "";
			return {
				token: token,
			};
		},
		// 是否是超级管理员
		isSuperAdmin() {
			const userInfoStr = window.sessionStorage.getItem("userInfo");
			if (!userInfoStr) return false;
			const userInfo = JSON.parse(userInfoStr);
			if (!userInfo) return false;
			if (userInfo.superAdminFlag === "1") return true;
			return false;
		},
	},
	mounted() {
		const userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));
		// 代理商
		if (userInfo.sysAgent.contractLevel == "1410436558597210114") {
			this.applyOrgTypeOptions = [
				{
					value: "3",
					label: "代理商",
				},
			];
		}
		// 获取机型及开发名
		this.getRepairDevice();
		// 获取省市县三级
		this.getDataAddr();
		// 获取单个索赔信息
		const claimId = sessionStorage.getItem("claimId") || this.$route.query.claimId;
		if (claimId) {
			this.getClaimMaterialInfo(claimId);
			this.getAuditLogList(claimId);
		} else {
			this.form.id ? delete this.form.id : "";
		}
	},
	methods: {
		// 获取审核日志
		getAuditLogList(claimId) {
			let self = this;
			self.$request.post("getAuditLogList", false, { id: claimId }, function (r) {
				if (r.code == "0") {
					let logList = [];
					for (const element of r.data) {
						if (element.remark) {
							logList.push(element);
						}
					}
					self.logList = logList;
					console.log("审核日志", self.logList);
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 获取单个索赔信息
		getClaimMaterialInfo(claimId) {
			let self = this;
			claimMaterialInfo(claimId, true)
				.then((r) => {
					if (r.code == "0") {
						self.auditStatus = r.data?.currentAudit?.auditStatus || "";
						self.form.id = r.data.id;
						self.form.matertialType = String(r.data.matertialType);
						self.form.repairType = r.data.repairType;
						self.form.applyOrgType = String(r.data.applyOrgType);
						self.form.applyOrgId = r.data.applyOrgId;
						self.form.repairDeviceId = r.data.repairDeviceId;
						self.form.repairDeviceNumber = r.data.repairDeviceNumber;
						self.form.partsClaimMaterial = {
							id: r.data.partsClaimMaterial.id,
							startUseDate: r.data.partsClaimMaterial.startUseDate, // 开始使用日
							issueDate: r.data.partsClaimMaterial.issueDate, // 问题发生日
							pagesUsed: r.data.partsClaimMaterial.pagesUsed, // 使用张数
							failureSymptom: r.data.partsClaimMaterial.failureSymptom, // 故障现象
							failureAction: r.data.partsClaimMaterial.failureAction, // 故障措施
							additionalNotes: r.data.partsClaimMaterial.additionalNotes, // 补充说明栏
							ricohOutboundFileIdList: [], // 理光出库一览表
							ricohPurchaseFileIdList: [], // 理光购货发票
							faultyPartsFileIdList: [], // 故障件照片和样张
						};
						self.form.partsClaimCustomer = {
							allAddress: [], // 省市县三级
							id: r.data.partsClaimCustomer.id, // 用户名
							userName: r.data.partsClaimCustomer.userName, // 用户名
							contactName: r.data.partsClaimCustomer.contactName, // 联系人姓名
							userPhone: r.data.partsClaimCustomer.userPhone, // 用户电话
							province: r.data.partsClaimCustomer.province, // 省
							city: r.data.partsClaimCustomer.city, // 市
							district: r.data.partsClaimCustomer.district, // 区县
							addressDetail: r.data.partsClaimCustomer.addressDetail, // 详细地址
						};
						let aa = [];
						for (const element of r.data.partsDetailList) {
							aa.push({
								partsAmount: element.partsAmount,
								partsName: element.partsName,
								partsNumber: element.partsNumber,
							});
						}
						self.form.partsDetailList = [...aa];
						// 申请方公司和人员
						self.getApplyList(r.data.applyOrgName);
						self.getApplyUser();

						// 机型及开发名
						r.data.repairModelId ? (self.form.repairDevices = [r.data.repairModelId, r.data.repairDeviceId]) : [];
						// 省市区
						r.data.partsClaimCustomer.province
							? (self.form.partsClaimCustomer.allAddress = [
									r.data.partsClaimCustomer.province,
									r.data.partsClaimCustomer.city,
									r.data.partsClaimCustomer.district,
								])
							: [];
						self.ricohOutboundFileIdList = r.data.partsClaimMaterial.ricohOutboundFileList;
						self.ricohPurchaseFileIdList = r.data.partsClaimMaterial.ricohPurchaseFileList;
						self.faultyPartsFileIdList = r.data.partsClaimMaterial.faultyPartsFileList;

						if (r.data.currentAudit) {
							self.form.applyOrgName = r.data.applyOrgName;
							if ([-41].includes(r.data.currentAudit.auditStatus)) {
								self.auditStatusMsg = "材料重新提交";
							}
							self.form.serialNumber = r.data.serialNumber;
						}
					} else {
						self.$message.error(r.msg);
					}
				})
				.catch((error) => {
					console.log(error);
				});
		},
		// 变更申请类型
		changeApplyOrgType() {
			this.form.applyOrgId = "";
			this.applyOrgFlag = false;
			this.applyUserList = [];
			this.getApplyList();
		},
		// 获取申请方信息
		getApplyList(query) {
			let self = this;
			const params = { applyOrgType: self.form.applyOrgType };
			if (query) {
				params.nameLike = query;
			}
			self.$request.post("getApplyList", false, params, function (r) {
				if (r.code == "0") {
					self.applyOptions = r.data;
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 获取申请方人员信息
		getApplyUser() {
			let self = this;
			const params = { agentId: self.form.applyOrgId };
			// 是否先行赔付
			if (this.form.applyOrgType == "3") {
				for (const element of self.applyOptions) {
					if (element.isPrepaid == 1) {
						self.isPrepaid = "0";
						self.isPrepaidFlag = true;
					}
				}
			}
			self.$request.post("getApplyUser", false, params, function (r) {
				if (r.code == "0") {
					self.applyOrgFlag = true;
					self.applyUserList = r.data;
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 获取机型及开发名
		getRepairDevice() {
			let self = this;
			self.$request.get("getRepairDevice", false, {}, function (r) {
				if (r.code == "0") {
					// 删除最后一级的children属性
					for (const element of r.data) {
						for (let index = 0; index < element.children.length; index++) {
							const extAttr = element.children[index];
							delete extAttr.children;
						}
					}
					self.repairDeviceOptions = r.data;
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 获取省市县三级
		getDataAddr() {
			let self = this;
			self.$request.get("getDataAddr", false, {}, function (r) {
				if (r.code == "0") {
					self.addressOptions = r.data;
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 上传前校验
		handleBeforeUpload(file) {
			if (this.isSuperAdmin) {
				// 超管单个文件大小限制1G
				const limitSize = file.size / 1024 / 1024 / 1024 <= 1;
				if (!limitSize) {
					this.$message.warning("文件大小不能超过1G");
					return false;
				}
			} else {
				// 非超管单个文件大小限制255M
				// 2022-07-31 应客户要求改为200M
				const limitSize = file.size / 1024 / 1024 <= 200;
				if (!limitSize) {
					this.$message.warning("文件大小不能超过200M");
					return false;
				}
			}
		},
		// 上传失败回调
		handleError(err, file, fileList) {
			console.log(`handleError`);
			console.log(err);
		},
		// 上传成功回调
		handleSuccess(type, response, file, fileList) {
			if (type === "ricohOutbound") {
				this.ricohOutboundFileIdList.push(file.response.data); // 更新 理光出库一览表 列表
			} else if (type === "ricohPurchase") {
				this.ricohPurchaseFileIdList.push(file.response.data); // 更新 理光购货发票 列表
			} else if (type === "faultyParts") {
				this.faultyPartsFileIdList.push(file.response.data); // 更新 故障件照片和样张 列表
			}
		},
		// 删除上传文件
		handleAttachFileRemove(file, fileListName) {
			this[fileListName].splice(this[fileListName].indexOf(file), 1);
		},
		// 新增机器零件
		addPartInfo() {
			this.form.partsDetailList.push({
				partsName: "",
				partsNumber: "",
				partsAmount: "1",
			});
		},
		// 删除机器零件
		removePartInfo(index) {
			this.form.partsDetailList.splice(index, 1);
		},
		// 返回列表页
		handleBack() {
			this.$router.push({
				path: sessionStorage.getItem("claimRoute"),
			});
		},
		// 暂存/提交  请确认索赔申请资料真实有效以及申请零件在索赔范围内
		handleSubmit: debounce(function (isSubmit) {
			let self = this;
			self.form.isSubmit = isSubmit;
			if (self.form.repairType == "") {
				self.$message.error("索赔类型不能为空");
				return;
			}
			if (self.form.applyOrgType == "" || self.form.applyOrgId == "") {
				self.$message.error("申请方信息不能为空");
				return;
			}
			// 提交
			if (isSubmit == "1") {
				// 该机构暂无索赔管理员，无法进行索赔申请
				if (self.applyUserList.length == 0) {
					self.$message.error("该机构暂无索赔管理员，无法进行索赔申请");
					return;
				}
				// 理光出库一览表
				if (self.ricohOutboundFileIdList.length == 0) {
					self.$message.error("请上传理光出库一览表");
					return;
				}
				// 理光购货发票
				if (self.ricohPurchaseFileIdList.length == 0) {
					self.$message.error("请上传理光购货发票");
					return;
				}
				// 故障样张或照片
				if (self.faultyPartsFileIdList.length == 0) {
					self.$message.error("请上传故障件照片和样张");
					return;
				}
				// 商品(耗材)信息
				if (self.form.partsDetailList.length == 0) {
					self.$message.error(`${self.partTitleObj[self.form.repairType]}不能为空`);
					return;
				}
				self.$confirm(`请确认索赔申请资料真实有效以及申请零件在索赔范围内`, "", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
				})
					.then(() => {
						self.$refs["form"].validate((valid, fields) => {
							if (valid) {
								self.handleForm();
							} else {
								self.$message.error("维修信息不完整，请完善信息。");
								return false;
							}
						});
					})
					.catch(() => {});
			}
			// 暂存
			else {
				self.handleForm();
			}
		}, 500),
		// 处理form数据
		handleForm() {
			let self = this;
			// 机型及开发名 赋值
			self.form.repairModelId = self.form.repairDevices[0];
			self.form.repairDeviceId = self.form.repairDevices[1];
			// 省市县 赋值
			self.form.partsClaimCustomer.province = self.form.partsClaimCustomer.allAddress[0];
			self.form.partsClaimCustomer.city = self.form.partsClaimCustomer.allAddress[1];
			self.form.partsClaimCustomer.district = self.form.partsClaimCustomer.allAddress[2];
			// // 删除 机型及开发名多级
			// delete self.form.repairDevices;
			// // 删除 省市县
			// delete self.form.partsClaimCustomer.allAddress;
			self.form.partsClaimMaterial.ricohOutboundFileIdList = [];
			self.form.partsClaimMaterial.ricohPurchaseFileIdList = [];
			self.form.partsClaimMaterial.faultyPartsFileIdList = [];
			if (self.ricohOutboundFileIdList.length > 0) {
				for (const element of self.ricohOutboundFileIdList) {
					self.form.partsClaimMaterial.ricohOutboundFileIdList.push(element.id);
				}
			}
			if (self.ricohPurchaseFileIdList.length > 0) {
				for (const element of self.ricohPurchaseFileIdList) {
					self.form.partsClaimMaterial.ricohPurchaseFileIdList.push(element.id);
				}
			}
			if (self.faultyPartsFileIdList.length > 0) {
				for (const element of self.faultyPartsFileIdList) {
					self.form.partsClaimMaterial.faultyPartsFileIdList.push(element.id);
				}
			}
			console.log("提交数据:", self.form);

			const postUrl = self.form.id ? "updateClaimMaterial" : "addClaimMaterial";
			self.$request.post(postUrl, true, self.form, function (r) {
				if (r.code == "0") {
					self.$message({
						message: "操作成功",
						type: "success",
					});
					self.handleBack();
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 撤销
		handleRevocation() {
			this.$confirm(`确认撤销此次索赔吗?`, "", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
			})
				.then(() => {
					let self = this;
					const params = {
						relatedId: self.form.id,
						auditStatus: "-1",
					};
					self.$request.post("claimWarrantyAuditAdd", true, params, function (r) {
						if (r.code == "0") {
							self.$message({
								message: "操作成功",
								type: "success",
							});
							self.handleBack();
						} else {
							self.$message.error(r.msg);
						}
					});
				})
				.catch(() => {});
		},
	},
};
</script>

<style lang="scss" scoped>
.create-page {
	display: flex;
	flex-direction: column;
}
.create-tab {
	width: 160px;
	border-bottom: 2px solid #409eff;
	text-align: center;
	padding-bottom: 10px;
	margin-bottom: 20px;
}
.create-section {
	padding-bottom: 20px;
	border: 1px solid #ae8d5a;
	border-radius: 8px;
	h3 {
		height: 60px;
		line-height: 60px;
		padding: 0 20px;
		border-bottom: 1px solid #dcdfe6;
	}
}
.type-list {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr; /* 定义列 */
	gap: 20px; /* 间距 */
	margin: 20px 20px 0;
	.claim-type {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		padding: 34px 20px;
		border-radius: 4px;
		border: 2px solid rgba(0, 0, 0, 0.15);
		font-size: 20px;
		font-weight: 500;
		color: #aaa7a7;
		cursor: pointer;
		.tip {
			margin-top: 10px;
			font-weight: 500;
			font-size: 12px;
			color: #666;
			word-break: break-all;
		}
	}
	.selected {
		border-color: #409eff;
		color: #409eff;
	}
}
.grid-box {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr; /* 定义列 */
	gap: 20px; /* 间距 */
	margin: 0 20px;
	.el-cascader,
	.el-date-editor {
		width: 100%;
	}
}
.grid-box1 {
	grid-template-columns: 1fr 2fr; /* 定义列 */
}
/* 使用深度选择器 */
.el-form-item ::v-deep .el-form-item__label {
	padding: 0;
}
.hidden-label ::v-deep .el-form-item__label {
	opacity: 0;
}
.el-form-item1 ::v-deep .el-form-item__label {
	line-height: 20px;
}
.claim-user-box {
	margin: 0 20px;
	button {
		margin-left: 10px;
	}
}
.claim-user {
	color: rgba(0, 0, 0, 0.87);
	border: none;
	cursor: default;
	height: 34px;
	display: inline-flex;
	outline: 0;
	padding: 2px 10px;
	font-size: 0.8125rem;
	box-sizing: border-box;
	transition:
		background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
		box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
	align-items: center;
	white-space: nowrap;
	border-radius: 16px;
	vertical-align: middle;
	justify-content: center;
	text-decoration: none;
	background-color: #e0e0e0;
	cursor: pointer;
	img {
		color: transparent;
		width: 100%;
		height: 100%;
		object-fit: cover;
		text-align: center;
		text-indent: 10000px;
	}
}
.radio-box {
	margin: 0 20px;
	p {
		color: rgba(0, 0, 0, 0.54);
		padding: 0;
		font-size: 1rem;
		font-weight: 400;
		line-height: 1;
		letter-spacing: 0.00938em;
		margin: 10px 0;
	}
}
.el-radio ::v-deep .el-radio__inner {
	width: 20px;
	height: 20px;
}
.el-radio ::v-deep .el-radio__label {
	font-size: 16px;
	color: #000;
}
.upload-box {
	margin: 10px 20px;
	h4,
	p {
		margin-bottom: 10px;
	}
	p {
		color: rgba(0, 0, 0, 0.54);
		padding: 0;
		font-size: 1rem;
		font-weight: 400;
		line-height: 1;
		letter-spacing: 0.00938em;
	}
}
.upload-box ::v-deep .el-upload-dragger {
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 120px;
	width: 120px;
	.el-icon-upload {
		font-size: 40px;
		line-height: unset;
		margin: unset;
	}
}
.create-footer {
	display: flex;
	div {
		flex: 1;
	}
	margin-top: 10px;
}
.fixed-btn-box {
	position: fixed;
	top: 80px;
	right: calc(10vw - 80px);
	button {
		display: block;
		margin-left: 0;
		margin-bottom: 10px;
	}
}
.flex {
	display: flex;
}
.flex-1 {
	flex: 1;
	padding: 10px;
}
.part-info-box {
	margin: 10px 20px;
	box-shadow:
		0px 2px 1px -1px rgba(0, 0, 0, 0.2),
		0px 1px 1px 0px rgba(0, 0, 0, 0.14),
		0px 1px 3px 0px rgba(0, 0, 0, 0.12);
	border-radius: 5px;
	.delete-btn-box {
		text-align: right;
		font-size: 20px;
		cursor: pointer;
		padding-right: 5px;
	}
}
.part-info-item {
	display: flex;
	align-items: flex-end;
	.el-form-item {
		flex: 1;
		margin-bottom: 5px;
	}
	i {
		font-size: 28px;
		cursor: pointer;
		margin-bottom: 10px;
	}
}
.part-info-box-right {
	background-color: rgba(0, 0, 0, 0.02);
}
.mt20 {
	margin-top: 20px;
}
.ml20 {
	margin-left: 20px;
}
.color-red {
	color: red;
}
.mr20 {
	margin: 0 20px;
}
.notice {
	color: #409eff;
	display: inline-block;
	text-decoration: underline;
	margin-left: 30px;
	cursor: pointer;
}
iframe {
	width: 100%;
	height: 70vh;
}
.create-page ::v-deep .el-dialog__header {
	display: none;
}
.create-page ::v-deep .el-dialog__body {
	padding: 0;
}
.prepaid-box {
	margin: 10px 20px;
	p {
		margin-bottom: 10px;
	}
}
.log-section {
	.el-table {
		margin-left: 20px;
		width: calc(100% - 40px);
		margin-top: 20px;
		font-size: 12px;
	}
}
</style>
<style>
.create-tooltip {
	width: 220px;
}
</style>
